import { ReactNode } from "react";

import { StacksRequiringAttentionContext } from "./context";
import useStacksRequiringAttention from "./useStacksRequiringAttention";

type DashboardWidgetsStacksRequiringAttentionProviderProps = {
  children: ReactNode;
};

const DashboardWidgetsStacksRequiringAttentionProvider = ({
  children,
}: DashboardWidgetsStacksRequiringAttentionProviderProps) => {
  const stacksRequiringAttention = useStacksRequiringAttention();

  return (
    <StacksRequiringAttentionContext.Provider value={stacksRequiringAttention}>
      {children}
    </StacksRequiringAttentionContext.Provider>
  );
};

export default DashboardWidgetsStacksRequiringAttentionProvider;
